import React from "react";

const Policy = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src="https://mooshir.com/assets/pdf/mooshir-privacy-policy-v2.0.pdf"
        title="Mooshir Privacy Policy"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default Policy;
